import twitterIcon from '@/assets/images/project/sns/twitter.png'
import facebookIcon from '@/assets/images/project/sns/facebook.png'
import instagramIcon from '@/assets/images/project/sns/instagram.png'
import webIcon from '@/assets/images/project/sns/web.png'

const defaultItemSocial = {
  twitter: {
    type: 'social',
    value: 'https://twitter.com/',
    image: twitterIcon,
    scale_x: 1,
    scale_y: 1,
    scale_z: 1,
    x: -0.75,
    y: 0,
    z: -1,
    width: 0.5,
    height: 0.5,
  },
  facebook: {
    type: 'social',
    value: 'https://www.facebook.com/',
    image: facebookIcon,
    scale_x: 1,
    scale_y: 1,
    scale_z: 1,
    x: 0,
    y: 0,
    z: -1,
    width: 0.5,
    height: 0.5,
  },
  instagram: {
    type: 'social',
    value: 'https://www.instagram.com/',
    image: instagramIcon,
    scale_x: 1,
    scale_y: 1,
    scale_z: 1,
    x: 0.75,
    y: 0,
    z: -1,
    width: 0.5,
    height: 0.5,
  },
  web: {
    type: 'social',
    value: '',
    image: webIcon,
    scale_x: 1,
    scale_y: 1,
    scale_z: 1,
    x: 1.5,
    y: 0,
    z: -1,
    width: 0.5,
    height: 0.5,
  },
}

export default defaultItemSocial
